import React, { useEffect, useState, useRef } from "react";
import {
  Checkbox,
  Input,
  Tooltip,
  Button,
  Dropdown,
  Space,
  Table,
  Card,
  DatePicker,
} from "antd";
import {
  PlusOutlined,
  DeleteTwoTone,
  DeleteOutlined,
  SearchOutlined,
  Highlighter,
  FilterOutlined,
  EditOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import backArrow from "../../../../../images/pagination/chevron-left.svg";
import avatar from "../../../../../images/avatar.png";
import deleteRed from "../../../../../images/deleteRed.png";
import editLabelIcon from "../../../../../images/edit-label.svg";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  addToCompare,
  getSelectedRevision,
  listAllRevisions,
  listUserRevisions,
  deleteVariant,
  setVariantsData,
  getMetrics,
  setSkillId,
  updateRevisionLabel
} from "../../../../../redux/actions/skill";
import moment from "moment";
import { notify } from "../../../../../components/Snack";
import {
  minimizeView,
  setAdminProcessView,
} from "../../../../../redux/actions/appActions";
import Loader from "../../../../../components/loader";

const ProcessDiscoverySideBar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [showVariants, setShowVariants] = useState(false);
  let [search, setSearch] = useState("");

  let [searchLabel, setSearchLabel] = useState("");
  let [isLabelEditing, setIsLabelEditing] = useState(0);
  let [labelEditText, setLabelEditText] = useState("");

  const [activeId, setActiveId] = useState("");
  const [activeVariantData, setActiveVariantData] = useState("");
  const [variantIds, setVariantId] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [processCycle, setProcessCycle] = useState(0);
  const [appList, setApplist] = useState([]);
  const [appCount, setAppCount] = useState(0);
  const [participantCount, setParticipantCount] = useState([]);
  let [startDate, setStartDate] = useState(null);
  let [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(false);

  const searchInput = useRef(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [isLabelFiltered, setIsLabelFiltered] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 15,
      position: ["bottomCenter"],
    },
  });
  const skill = useSelector((state) => state?.skillReducer?.trainDraft);
  const skillID = useSelector((state) => state?.skillReducer?.skillId);

  const allVariants = useSelector((state) => state?.skillReducer?.allVariants);
  const metrics = useSelector((state) => state?.skillReducer?.rpdMetric);

  const flowToCompare = useSelector(
    (state) => state?.skillReducer?.compareFlow
  );

  const user = useSelector((state) => state.userReducer?.user);

  const userDetails = useSelector(
    (state) => state.organizationReducer.currentOrganization
  );
  const currentUser = useSelector(
    (state) => state.organizationReducer.currentOrgUser
  );

  const selectStartDate = (dateValue) => {
    const dateText = moment(dateValue).format("YYYY-MM-DD");
    setStartDate(dateText);
  };
  const selectEndDate = (dateValue) => {
    const dateText = moment(dateValue).format("YYYY-MM-DD");
    setEndDate(dateText);
  };

  const getColumnSearchProps = () => ({
    filterDropdown: ({ clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          // ref={searchInput}
          placeholder="Search Email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onPressEnter={(e) => {
            setIsFiltered(true);

            handleSearch(e.target.value);
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              handleSearch(e.target.value);
              setIsFiltered(true);

              close();
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setIsFiltered(false);
              setSearch("");

              clearFilters && handleReset(clearFilters);
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          fontSize: "16px",
          color: isFiltered ? "#1890ff" : undefined,
        }}
      />
    ),
  });

  const getColumnSearchPropsLabel = () => ({
    filterDropdown: ({ clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          // ref={searchInput}
          placeholder="Search Label"
          value={searchLabel}
          onChange={(e) => setSearchLabel(e.target.value)}
          onPressEnter={(e) => {
            setIsLabelFiltered(true);

            handleSearch(e.target.value);
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              handleSearch(e.target.value);
              setIsLabelFiltered(true);

              close();
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setIsLabelFiltered(false);
              setSearchLabel("");

              clearFilters && handleReset(clearFilters);
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          fontSize: "16px",
          color: isLabelFiltered ? "#1890ff" : undefined,
        }}
      />
    ),
  });

  const columns = [
    {
      title: "Variant Id",
      dataIndex: "revision",
    },
    {
      title: "Email",
      dataIndex: "organization.email",
      ...getColumnSearchProps(),
    },
    {
      title: "Apps Involved",
      dataIndex: "appsUsed",
    },
    {
      title: "Label",
      dataIndex: "label",
      ...getColumnSearchPropsLabel(),
      render: (_, record) => (
        isLabelEditing == record.id ?
        <Input className="label-update" value={labelEditText}
        onChange={(e) => {
          e.stopPropagation();
          setLabelEditText(e.target.value)
        }}
        onBlur={(e) => {
          setIsLabelEditing(0);
          dispatch(updateRevisionLabel(record.id, e.target.value)).then(() => {
            handleSearch();
          });
        }} />
        :
        (
        <div className="flex-label" style={{width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px'}}>
          { record?.label < 1 ? <p style={{width: '5px', margin: 0}}></p> : record?.label}
          <img 
          onClick={(e) => {
            setLabelEditText(record?.label)
            e.stopPropagation()
            setIsLabelEditing(record.id)
          }} 
          src={editLabelIcon} width="12" height="12" style={{flex: '0 0 12px'}} />
        </div>
        )
        
      ),
      editable: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (date) => moment(date).format("YYYY-MM-DD, h:mm:ss a"),
      filterDropdown: ({ clearFilters, close }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div style={{ marginBottom: "10px" }}>
            <Space>
              <DatePicker
                allowClear={false}
                value={startDate ? moment(startDate, "YYYY-MM-DD") : null}
                placeholder="Start date"
                onChange={(date) => selectStartDate(date)}
              />
              <DatePicker
                allowClear={false}
                value={endDate ? moment(endDate, "YYYY-MM-DD") : null}
                placeholder="End date"
                onChange={(date) => selectEndDate(date)}
              />
            </Space>
          </div>
          <Space>
            <Button
              className="btn-primary"
              type="primary"
              onClick={() => {
                if (moment(startDate).isValid() && moment(endDate).isValid()) {
                  setDateFilter(true);
                  handleSearch();
                } else {
                  dispatch(
                    notify("error", "Please enter both start and end dates")
                  );
                }
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
                borderRadius: "3px",
                padding: "3px",
                height: "initial",
              }}
            >
              Search
            </Button>
            <Button
              class="ant-btn ant-btn-default ant-btn-sm"
              onClick={() => {
                setDateFilter(false);
                selectStartDate(null);
                selectEndDate(null);
                
                handleReset(clearFilters);
              }}
              size="small"
              style={{
                width: "90px",
                border: "1px solid #02ce9d",
                color: "#02ce9d",
                "border-radius": "3px",
                padding: "3px",
                height: "initial",
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
              style={{
                color: "#ff3333",
              }}
            >
              Close
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <FilterOutlined
          style={{
            fontSize: "16px",
            color: dateFilter ? "#1890ff" : undefined,
          }}
        />
      ),
    },
    {
      title: "Process Time",
      dataIndex: "processTime",
    },
    ,
  ];

  const handleSearch = async () => {
    setLoading(true);
    let _data;
    let start = startDate
      ? moment(startDate, "YYYY-MM-DD HH:mm:ss")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      : null;
    let end = endDate
      ? moment(endDate, "YYYY-MM-DD HH:mm:ss")
          .utc()
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm:ss")
      : null;
    if (userDetails?.role_id == "2") {
      _data = await dispatch(
        listAllRevisions(
          skill?.id,
          tableParams?.pagination,
          search,
          searchLabel,
          start,
          end
        )
      );
    } else {
      _data = await dispatch(
        listUserRevisions(
          skill?.id,
          tableParams?.pagination,
          search,
          searchLabel,
          startDate,
          endDate
        )
      );
    }
    getAdminMetrics(_data?.data?.revisions);

    setData(_data?.data?.revisions);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: _data?.data?.total,
      },
    });
    setLoading(false);
  };
  const handleReset = async (clearFilters) => {
    // setSearch("");
    // setSearchLabel("");
    // setStartDate(null);
    // setEndDate(null);
    //clearFilters();

    setLoading(true);
    let _data;
    if (userDetails?.role_id == "2") {
      _data = await dispatch(
        listAllRevisions(
          skill?.id,
          tableParams?.pagination,
          (search = ""),
          (searchLabel = ""),
          (startDate = null),
          (endDate = null)
        )
      );
    } else {
      _data = await dispatch(
        listUserRevisions(
          skill?.id,
          tableParams?.pagination,
          (search = ""),
          (searchLabel = ""),
          (startDate = null),
          (endDate = null)
        )
      );
    }
    getAdminMetrics(_data?.data?.revisions);

    setData(_data?.data?.revisions);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: _data?.data?.total,
      },
    });
    setLoading(false);
  };

  const fetchData = async () => {
    let start = startDate;
    let end = endDate;
    setLoading(true);
    let _data;
    if (userDetails?.role_id == "2") {
      _data = await dispatch(
        listAllRevisions(
          skillID,
          tableParams?.pagination,
          search,
          searchLabel,
          start,
          end
        )
      );
    } else {
      _data = await dispatch(
        listUserRevisions(
          skillID,
          tableParams?.pagination,
          search,
          searchLabel,
          start,
          end
        )
      );
    }
    if (_data?.data?.revisions) {
      getAdminMetrics(_data?.data?.revisions);
    }

    setData(_data?.data?.revisions);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: _data?.data?.total,
      },
    });
    setLoading(false);
  };
  useEffect(() => {
    if (skillID) {
      fetchData();
    }
    return () => {
      setVariantId([]);
      dispatch(setVariantsData([]));
    };
  }, [skillID, skill]);

  useEffect(() => {
    if (skillID) {
      fetchData();
    }
  }, [tableParams?.pagination?.current]);

  // useEffect(() => {
  //   if (skillID && userDetails?.role_id == "2") {
  //     dispatch(getMetrics(skillID));
  //   }
  // }, [skillID]);

  const handleChange = () => {
    history.goBack();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    const selectedFlowFromState = flowToCompare.filter((item) => item.id !== newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
    newSelectedRowKeys?.map((i) => {});
    let setFlowForCompare = [];
    if (newSelectedRowKeys?.length) {
      newSelectedRowKeys.map((k) => {
        data.filter((d) => {
          if (d.id == k) {
            d["skillName"] = skill?.SKILL_NAME;
            d["skillDescription"] = skill?.SKILL_DESCRIPTION;

            setFlowForCompare = [...setFlowForCompare, d];            
          }
        });
      });
      setFlowForCompare = [...new Set(selectedFlowFromState.concat(setFlowForCompare))]
      dispatch(addToCompare(setFlowForCompare));
    } else {
      dispatch(addToCompare([]));
    }
  };

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const handleTableChange = (pagination, filters) => {
    console.log(filters, "filtrer");
    setTableParams({
      pagination,
    });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  const viewVariant = (d) => {
    if(isLabelEditing == 0){
    setActiveId(d.id);
    setActiveVariantData(d);
    dispatch(getSelectedRevision(d.documentId, d.id));
    }
    // getAdminMetrics(data);
  };
  const onChange = (e, d) => {
    if (e.target.checked == true) {
      d["skillName"] = skill?.SKILL_NAME;
      d["skillDescription"] = skill?.SKILL_DESCRIPTION;

      let setFlowForCompare = [...flowToCompare, d];
      dispatch(addToCompare(setFlowForCompare));
      setVariantId([...variantIds, d.id]);
    } else {
      let updatedData = flowToCompare.filter((item) => item.id !== d?.id);
      let filteredVariant = variantIds.filter((id) => id !== d?.id);
      setVariantId(filteredVariant);
      dispatch(addToCompare(updatedData));
    }
  };
  const isCheckboxDisabled = (id) => {
    return variantIds.length >= 2 && !variantIds.includes(id);
  };

  const deleteRevisionById = async () => {
    setIsDeleting(true);
    const result = await dispatch(deleteVariant(selectedRowKeys));
    setIsDeleting(false);
    if (result?.data?.status) {
      dispatch(notify("success", "Deleted Successfully"));
      await fetchData();
    } else {
      dispatch(notify("error", "Something went wrong"));
    }
  };
  const getAdminMetrics = (variantData) => {
    if (variantData) {
      let totalVariants = variantData?.length;
      // let totalProcessTime = 0;
      // let participants = new Set();

      variantData?.map((ele) => {
        let appUsed = new Set();
        let _pc = calculateProcessTime(ele);
        let _avgPc = (_pc / 60).toFixed(2);
        ele["processTime"] = _avgPc + " " + "mins";
        // participants.add(ele["organization.email"]);
        // totalProcessTime = totalProcessTime + _pc;
        let addAppsData = listAllAppsInvolved(ele);
        addAppsData?.forEach((a) => {
          appUsed.add(a);
        });
        ele["appsUsed"] = appUsed?.size ?? 0;
      });
      // let averageProcessTime = (totalProcessTime / totalVariants / 60).toFixed(2);
      // setProcessCycle(isNaN(averageProcessTime) ? 0 : averageProcessTime);
      // setParticipantCount([...participants]);
      setData(variantData);
    }
  };
  const calculateProcessTime = (data) => {
    let diffInSecs;
    let lastRecordedData =
      data?.document?.actions[data?.document?.actions?.length - 1]?.timeStamp ??
      0;
    let firstRecordedData = data?.document?.actions[0]?.timeStamp ?? 0;

    if (lastRecordedData && firstRecordedData) {
      diffInSecs = (lastRecordedData - firstRecordedData) / 1000;
    } else {
      diffInSecs = 0;
    }
    return diffInSecs;
  };
  const listAllAppsInvolved = (data) => {
    let appUsed = new Set();
    data?.document?.actions?.map((item) => {
      if (item?.origin == "desktop") {
        appUsed.add(item?.app_name);
      } else {
        appUsed.add("browser");
      }
    });
    return appUsed;
  };

  const getrowClass = (record) => {
    return record.id === activeId ? "clickable-row-active" : "clickable-row";
  };
  const loadMetrics = () => {
    history.push(`/dashboard/skills/viewChart/${skillID}`);
  };
  return (
    <React.Fragment>
      <div className="task-list process-sidebar" style={{ display: "none" }}>
        <div className="flex-sd-list">
          <div className="flex-title-sd-list">
            <div class="flex-sd-btn flex-csd-btn">
              <button
                class="btn btn-outline csd-back-btn"
                onClick={() => handleChange()}
              >
                <img src={backArrow} />
              </button>
              <h2 class="csd-title">Process Discovery</h2>
            </div>
            {userDetails?.role_id == "2" ? (
              <Tooltip title="View Analytics">
                <Button
                  type="primary"
                  shape="circle"
                  icon={<BarChartOutlined />}
                  onClick={() => {
                    loadMetrics();
                  }}
                />
              </Tooltip>
            ) : null}
          </div>
          {loading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {userDetails?.role_id == "2" ? (
                <div className="rpd-stats">
                  {/* <Card title="Applications Involved" className="card1">
                {appList?.length ?? 0}
              </Card> */}

                  {/* <Card title="No. of Participants" className="card4">
                    {metrics?.totalParticipantCount}
                  </Card>
                  <Card title="No. of Variants" className="card3">
                    {metrics?.totalVariants}
                  </Card>
                  <Card title="Average Process Time" className="card2">
                    {metrics?.avgProcessCycle} minutes
                  </Card> */}
                </div>
              ) : null}
              <div className="table-sidebar">
                <Space
                  style={{
                    margin: "12px 0",
                  }}
                  align="end"
                >
                  {isDeleting ? (
                    <Button disabled={true}>
                      <div class="sp sp-circle text-light"></div>
                    </Button>
                  ) : (
                    <Tooltip title="Delete">
                      <Button
                        onClick={deleteRevisionById}
                        disabled={!selectedRowKeys.length}
                        icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
                        shape="circle"
                        danger
                      ></Button>
                    </Tooltip>
                  )}
                </Space>
                <Table
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: (event) => {
                        viewVariant(record);
                      },
                    };
                  }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                  pagination={{
                    pageSize: tableParams?.pagination?.pageSize ?? 15,
                    total: tableParams?.pagination?.total,
                    current: tableParams?.pagination?.current,
                    showSizeChanger: false,
                    onChange: (page) =>
                      setTableParams({
                        ...tableParams,
                        pagination: {
                          ...tableParams.pagination,
                          current: page,
                        },
                      }),
                  }}
                  onChange={handleTableChange}
                  rowSelection={rowSelection}
                  rowClassName={getrowClass}
                  // scroll={{ y: 'calc(100vh - 17em)' }}
                  scroll={{ y: "calc(100vh - 17em)", x: 800 }}
                />{" "}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProcessDiscoverySideBar;
